import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  EntityCardBlueprint,
  EntityContentBlueprint,
} from '@backstage/plugin-catalog-react/alpha';

const shopFilter = (entity: {
  metadata: { annotations?: Record<string, string> };
}) => entity.metadata.annotations?.['techne.com/iac-runner'] === 'terragrunt';

const shopContent = EntityContentBlueprint.make({
  name: 'cluster-shop',
  params: {
    path: '/loja',
    title: 'GitOps',
    filter: shopFilter,
    loader: async () => {
      const { ShopContent } = await import('./ShopContent');
      return <ShopContent />;
    },
  },
});

const shopCard = EntityCardBlueprint.make({
  name: 'gitops-infra',
  params: {
    type: 'content',
    filter: shopFilter,
    loader: async () => {
      const { ShopContent } = await import('./ShopContent');
      return <ShopContent />;
    },
  },
});

export const clusterShopModule = createFrontendModule({
  pluginId: 'app',
  extensions: [shopContent, shopCard],
});
